module.exports = __webpack_public_path__ + "static/media/0021_IMG_LES_MURS_PAPYRUS_W_VPA2100_VERTICALE.aa7182fa.webp";